@use 'variables' as *;
@use 'mixins' as *;
@use 'sass:map';

$spinner-sizes: (
  'xl': 1.75rem,
  'l': 1.5rem,
  'm': 1.25rem,
  's': 1rem,
  'xs': 0.75rem
);

:host {
  display: inline-flex;
  vertical-align: middle;
  @include cat-select(none);

  &[hidden] {
    display: none;
  }
}

span {
  display: inline-flex;
}

svg {
  fill: none;
  stroke: currentColor;
  stroke-dasharray: 135px;
  stroke-dashoffset: 95px;
  stroke-linecap: round;
  stroke-width: 5px;
  transform-origin: center center;
  animation: spin 0.75s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite;
  width: 1em;
  height: 1em;
}

// ----- sizes

@mixin size($size) {
  .spinner-#{$size} svg {
    font-size: map.get($spinner-sizes, $size);
  }
}

@include size('xs');
@include size('s');
@include size('m');
@include size('l');
@include size('xl');

// ----- animation

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
